import React, { useEffect, useState } from 'react';
import { getDB } from '../../../app/crud/api';
import { getImageURL, hosts } from '../../../app/pages/home/utils';

const { apiHost } = hosts;

const LogoAndTitle = ({ textColor }) => {
  const [values, setValues] = useState({});

  const loadData = (collectionName = 'settingsDesign') => {
    getDB(collectionName)
      .then(response => response.json())
      .then(data => {
        const { sideBarTitle, logoSideBarExt } = data.response[0] || {};
        setValues({ sideBarTitle, logoSideBarExt })
      })
      .catch(error => console.log('error>', error));
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className='kt-aside-LogoAndTitle'>
      <img
        src={
          values.logoSideBarExt ? getImageURL('logoSideBar', 'settingsDesign', values.logoSideBarExt) : (
            `${window.location.origin}/media/misc/placeholder-image.jpg`
          )}
        alt='Logo'
      />
      <span style={{color: textColor}}>
        {values.sideBarTitle}
      </span>
    </div>
  );
}

export default (LogoAndTitle)
